import { createFileRoute } from "@tanstack/react-router"
import { teamSettingsDetailsViewStaticData } from "src/views/TeamSettingsDetailView/constants"
import { TeamSettingsDetailView } from "src/views/TeamSettingsDetailView/TeamSettingsDetailView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/")({
	component: TeamSettingsDetailView,
	staticData: teamSettingsDetailsViewStaticData,
})
